/**
 * Converts empty strings to undefined so they are omitted from URL search params.
 * If value is undefined, uses fallback instead.
 */
const toSearchParam = (value?: string, fallback?: string): string | undefined => {
  if (value !== undefined) return value || undefined;
  return fallback || undefined;
};

export default toSearchParam;
